import { Pipe, PipeTransform } from '@angular/core';
import * as jalalimoment from "jalali-moment";

@Pipe({
  name: 'ticketTimeMode'
})
export class TicketTimeModePipe implements PipeTransform {

  transform(value: Date): string {
    let date = new Date(value);
    return jalalimoment(date).locale('fa').fromNow(false);
  }

}


